import React, { Component } from 'react';
import _ from 'lodash';

// El drag and drop de este componente está en MenuElement.js
export default class Home extends Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	onClick(event) {
		this.props.item.size = parseInt(event.currentTarget.getAttribute('data-size'), 10);
		this.props.onElementSelect(this.props.item, event);
	}
	
	render() {

        const item  = this.props.item;

		// console.log('rendering SizeSelector');
		// console.log(item);

		const style = {
			top:  item.top,
			left: item.left
		}

		return (
			<div className="size-selector" ref={el => this.element = el} style={style}>
                <div className="size size-3" data-size="3" onClick={this.onClick.bind(this)}><img src={'img/element/' + item.src} width="30" role="presentation" draggable="false"/></div>
                <div className="size size-1" data-size="1" onClick={this.onClick.bind(this)}><img src={'img/element/' + item.src} width="30" role="presentation" draggable="false"/></div>
                <div className="size size-2" data-size="2" onClick={this.onClick.bind(this)}><img src={'img/element/' + item.src} width="30" role="presentation" draggable="false"/></div>

				<img className="dummy" src={'img/element/' + item.src} role="presentation" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/SizeSelector.js